import { render } from "./HolidayEdit.vue?vue&type=template&id=249f4616"
import script from "./HolidayEdit.vue?vue&type=script&lang=js"
export * from "./HolidayEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__